import { Component, Prop, h, Host } from '@stencil/core';

/**
 * Asks component for SignNow displaying article cards with links
 *
 * @product signnow
 * @source asks
 * @version 1.3.0
 * @category SignNow
 * @contentConfig Asks component for displaying linked article cards about eSignature topics
 * @slot heading - {required}, <me-heading tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Section heading
 * @slot subheading - <me-text> - Section description text
 * @slot cards - {required}, {multiple}, <features-card-type-6 href="..." itemscope itemtype="https://schema.org/ListItem" itemprop="itemListElement"> - Article card items
 * @example
 *   <sn-asks-type-1>
 *     <me-heading slot="heading" align="center" variant="3" tag="h2">The ins and outs of eSignature</me-heading>
 *     <me-text slot="subheading" align="center">Find everything you need to know about electronic signatures.</me-text>
 *     <features-card-type-6 slot="cards" href="/articles/signing" itemscope itemtype="https://schema.org/ListItem" itemprop="itemListElement">
 *       <me-picture slot="icon" src-set="https://marketing-static.signnow.com/349/images/e-signature/frame-7.png 1x" alt="frame-7"></me-picture>
 *       <me-heading slot="heading" variant="5" tag="h3">Signing documents</me-heading>
 *       <me-text slot="description">Learn how to sign documents quickly and securely.</me-text>
 *     </features-card-type-6>
 *   </sn-asks-type-1>
 */
@Component({
  tag: 'sn-asks-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNAsks {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <me-section class="sn-asks" yGap="2xl" yGapLg="5xl" role="region" aria-label="Features">
          <me-row direction="column" yGap="2xs" yGapLg="3xl" align="stretch">
            <me-column span="12">
              <slot name="heading"></slot>
              <slot name="subheading"></slot>
            </me-column>
            <me-column span="12">
              <div class="sn-asks__cards" itemScope itemType="https://schema.org/ItemList">
                <slot name="cards"></slot>
              </div>
            </me-column>
          </me-row>
        </me-section>
      </Host>
    );
  }
}
